import React from "react";

export default class ContactMap extends React.Component {
  render() {
    return (
      <>
        <div className="contact-page-google-map">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <iframe
                  title="Address"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3705.071640836176!2d72.14727667501926!3d21.777488161642633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395f5a7e8686a037%3A0xe3c17684b194390c!2sComputer%20Care!5e0!3m2!1sen!2sin!4v1763475137322!5m2!1sen!2sin"
                  allowfullscreen
                  className="contact-page-google-map__one"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
